export const PRODUCTS_BLOCK_ID = 'financingProducts'
